<template>
  <img
    v-if="!lazy"
    :src="`/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=360,h=270${photo.url.masterImage}`"
    :srcset="
      transformImageSrcSet(`
      /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=360,h=270${photo.url.masterImage} 360w,
      /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=30,w=720,h=540${photo.url.masterImage} 720w,
      /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=30,w=1080,h=810${photo.url.masterImage} 1080w`)
    "
    :alt="photoCaptionAltFormatter(photo.caption)"
    :sizes="sizes"
    v-bind="$attrs"
    width="360"
    height="270"
    fetchpriority="high"
    decoding="sync"
  />
  <img
    v-else
    loading="lazy"
    :src="`/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=360,h=270${photo.url.masterImage}`"
    :srcset="
      transformImageSrcSet(`
      /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=360,h=270${photo.url.masterImage} 360w,
      /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=30,w=720,h=540${photo.url.masterImage} 720w,
      /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=30,w=1080,h=810${photo.url.masterImage} 1080w`)
    "
    :alt="photoCaptionAltFormatter(photo.caption)"
    :sizes="sizes"
    v-bind="$attrs"
    width="360"
    height="270"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { photoCaptionAltFormatter } from '~/utility/photoCaptionAltFormatter'
import { transformImageSrcSet } from '../../../utility/image-url'

interface PrimaryPhotoType {
  caption?: string
  url: {
    masterImage: string
  }
}

@Component
class PrimaryPhoto extends Vue {
  @Prop({ required: true })
  photo: PrimaryPhotoType

  @Prop({ default: '100vw' })
  sizes: string

  @Prop({ default: true })
  lazy: boolean

  photoCaptionAltFormatter(caption) {
    return photoCaptionAltFormatter(caption)
  }

  transformImageSrcSet(srcset: string) {
    return transformImageSrcSet(srcset)
  }
}

export default toNative(PrimaryPhoto)
</script>
